import React, { useCallback } from "react";
import { Row, Col } from "@mtm/components";
import {
  Button,
  Typography,
  Card,
  Avatar,
  List,
  Skeleton,
  Space,
  Image,
} from "antd";
import { useHistory } from "react-router-dom";
import BackArrow from "../../assets/images/BackArrow.svg";
import Styles from "./ScheduleService.module.scss";
import { IServiceUserInfo } from "../../types/ServiceUserInfo";
import { useTripsCtx } from "../../context/TripDetailsContext";
import { rightArrow } from "../../assets/images";
import NewScheduleService from "./ScheduleServiceNew";
import { usersImage } from "../../assets/images";
import EllipsisText from "../../helpers/EllipsisText/EllipsisText";
import navigateAddServiceUser from "../../helpers/navigateAddServiceUser";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";
import GoogleLoader from "../../assets/Loader/GoogleSvgLoader/GoogleLoader";

const ScheduleService: React.FC = () => {
  const history = useHistory();
  const { serviceDataCtx, isLoading } = useTripsCtx();
  const { caregiverSummaryInfo, isLoadingPersonData } = usePersonSummaryCtx();
  const [serviceData] = serviceDataCtx;

  const handleBackButtonClick = useCallback(() => {
    history.push("/DashBoard");
  }, []);

  const handleSelectNewButtonClick = () =>
    navigateAddServiceUser(
      serviceData,
      caregiverSummaryInfo.personId,
      history,
      "ScheduleService"
    );

  const handleSelectButtonClick = useCallback((serviceUserId: number) => {
    history.push(
      `/DashBoard/ScheduleService/ScheduleServiceCalender/${caregiverSummaryInfo.personId}/${serviceUserId}`
    );
  }, []);

  return isLoading || isLoadingPersonData ? (
    <GoogleLoader />
  ) : (
    <>
      <Row className={Styles.desktopView}>
        <Col span={24}>
          <Row>
            <Col span={24} offset={4}>
              <Typography.Text
                onClick={handleBackButtonClick}
                className={Styles.backOptionButton}
              >
                <img alt="back" src={BackArrow} />
                Back
              </Typography.Text>
            </Col>
          </Row>
          <Row justify="center" gutter={[0, 32]}>
            <Col className="gutter-row">
              <Typography.Title level={4} className={Styles.sericeRequest}>
                SCHEDULE A SERVICE
              </Typography.Title>
            </Col>
          </Row>
          <Row justify="center" gutter={[0, 32]}>
            <Col className="gutter-row">
              <Typography.Title level={3} className={Styles.selectAServiceUser}>
                Select a service user
              </Typography.Title>
            </Col>
          </Row>
          <Row justify="center" gutter={[0, 32]}>
            <Col>
              {serviceData.length >= 0 && serviceData.length <= 5 && (
                <Row gutter={[16, 0]}>
                  <Col>
                    <Row gutter={[16, 0]}>
                      {serviceData.map((user: IServiceUserInfo, i: number) => (
                        <Col key={i}>
                          <Card
                            className={Styles.serviceUserCard}
                            hoverable
                            bordered
                          >
                            <Row
                              justify="center"
                              className={Styles.cardInsideTopPadding}
                            >
                              <Col>
                                <Avatar
                                  size={75}
                                  icon={
                                    <img
                                      alt={
                                        user.profileImageUrl
                                          ? "Profile"
                                          : "Default-Image"
                                      }
                                      src={user.profileImageUrl || usersImage}
                                    />
                                  }
                                />
                              </Col>
                            </Row>
                            <Row
                              justify="center"
                              className={Styles.cardInsideTopPadding}
                            >
                              <Col>
                                <Row justify="center">
                                  <Col>
                                    <Typography.Text
                                      className={Styles.sericeRequest}
                                    >
                                      <EllipsisText
                                        text={user.firstName}
                                        maxVisibleTextLength={12}
                                      />
                                    </Typography.Text>
                                  </Col>
                                </Row>
                                <Row justify="center">
                                  <Col>
                                    <Typography.Text
                                      className={Styles.serviceUserText}
                                    >
                                      <EllipsisText
                                        text={user.lastName}
                                        maxVisibleTextLength={12}
                                      />
                                    </Typography.Text>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row
                              justify="center"
                              className={Styles.cardInsideTopPadding}
                            >
                              <Col>
                                <Button
                                  type="primary"
                                  onClick={() =>
                                    handleSelectButtonClick(user.personId)
                                  }
                                  className={Styles.buttonSelect}
                                >
                                  Select
                                </Button>
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                  {serviceData.length < 25 && (
                    <Col>
                      <NewScheduleService
                        onAddNew={handleSelectNewButtonClick}
                      />
                    </Col>
                  )}
                </Row>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className={Styles.mobileView}>
        <Col span={22} offset={1}>
          <Row>
            <Col span={24}>
              <Typography.Text
                className={Styles.backOptionButton}
                onClick={handleBackButtonClick}
              >
                <img alt="back" src={BackArrow} />
                Back
              </Typography.Text>
            </Col>
          </Row>
          <Row justify="start" className={Styles.selectAServiceUser}>
            <Col className="gutter-row" offset={2}>
              <Space direction="vertical">
                <Typography.Text className={Styles.serviceRequest}>
                  SCHEDULE A SERVICE
                </Typography.Text>
                <Typography.Text className={Styles.title}>
                  Select a service user
                </Typography.Text>
              </Space>
            </Col>
          </Row>
          <Row justify="space-between" gutter={[0, 48]}>
            <Col span={22} offset={1}>
              {serviceData.length > 0 && serviceData.length <= 5 ? (
                <List
                  className={Styles.list}
                  size="large"
                  itemLayout="horizontal"
                  dataSource={serviceData}
                  renderItem={(item: IServiceUserInfo, index) => (
                    <Skeleton avatar title={false} loading={false} active>
                      <List.Item className={Styles.listItem} key={index}>
                        <List.Item.Meta
                          avatar={
                            <Avatar
                              size={42}
                              src={item.profileImageUrl || usersImage}
                            />
                          }
                          title={
                            <Typography.Text className={Styles.nameText}>
                              <EllipsisText
                                text={`${item.firstName} ${item.lastName}`}
                                maxVisibleTextLength={25}
                              />
                            </Typography.Text>
                          }
                        />
                        <Image
                          preview={false}
                          onClick={() => handleSelectButtonClick(item.personId)}
                          src={rightArrow}
                        />
                      </List.Item>
                    </Skeleton>
                  )}
                />
              ) : null}
            </Col>
          </Row>
          {serviceData.length < 25 && (
            <Row className={Styles.addNewTextRow}>
              <Col>
                <Typography.Text
                  className={Styles.addNewText}
                  onClick={handleSelectNewButtonClick}
                >
                  + Add New
                </Typography.Text>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

export default ScheduleService;
